import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        DropdownComponent,
    ],
    exports: [
        DropdownComponent,
    ],
})

export class DropdownModule {}
